// extracted by mini-css-extract-plugin
export var statItem = "_l6-1";
export var statsRow = "_l6-0";